import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Theme } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { OpenAPIV3_1 } from "openapi-types";
import _, { Dictionary } from 'lodash';


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(1),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export interface ResourcesProps {
    // method: OpenAPIV3_1.HttpMethods;
    pathKey: string;
    method: string;
    open: boolean;
    toggle: (event: React.SyntheticEvent, newExpanded: boolean) => void;
    header: React.ReactElement;
}

const getColor = (method: string) => (theme: Theme) => {
    if (method === 'get') {
        return theme.palette.primary.main;
    } else if (method === 'post') {
        return theme.palette.info.main;
    }
}

const Resources: React.FC<React.PropsWithChildren<ResourcesProps>> = ({ pathKey, method, open, toggle, header, children }) => {
    return <Accordion
        expanded={open}
        onChange={toggle}
    >
        <AccordionSummary>
            {header}
        </AccordionSummary>
        <AccordionDetails>
            {children}
        </AccordionDetails>
    </Accordion>
}

export default Resources;
